/**
 * Renders a contract `Money` object. Money is never a bare number on the wire
 * (contract §1) — formatting happens here, at the edge.
 *
 * Pass `fx` + `in` to show the value converted for display (e.g. a USD supplier offer
 * shown in AED on the comparison workbench). The original object is left untouched.
 */

import { formatMoney } from '../lib/format'
import { convert } from '../lib/fx'
import type { WireFx } from '../lib/api/wire'
import type { Currency, Money as MoneyType } from '../lib/types'

export function Money({
  value,
  in: target,
  fx,
  digits = 2,
  className,
  title,
}: {
  value: MoneyType | null | undefined
  in?: Currency
  fx?: WireFx
  digits?: number
  className?: string
  title?: string
}) {
  const shown = value && target && fx && value.currency !== target ? convert(value, target, fx) : value
  const original = value && shown && shown.currency !== value.currency ? formatMoney(value, digits) : undefined

  return (
    <span className={`mono${className ? ` ${className}` : ''}`} title={title ?? original}>
      {formatMoney(shown, digits)}
    </span>
  )
}
